import { schema } from 'normalizr';

export default function adDataSchema() {
  const keyframeSchema = new schema.Entity('keyframes', {}, {
    idAttribute: 'key',
  });

  const componentSchema = new schema.Entity('components', {}, {
    idAttribute: 'key',
  });

  const variantSchema = new schema.Entity('variants', {}, {
    idAttribute: 'key',
  });

  componentSchema.define({
    keyframes: [keyframeSchema],
    subComponents: [componentSchema],
  });

  variantSchema.define({
    components: [componentSchema],
  });

  const adStateSchema = new schema.Entity('adStates', {
    components: [componentSchema],
    variants: [variantSchema],
  }, {
    idAttribute: 'key',
  });
  return [adStateSchema];
}



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/schemas/adDataSchema.js